module.exports = __webpack_public_path__ + "img/xpera_web_transparent_white.16343e2f.png";